import React, { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useOrderSSE } from '../../hooks/useOrderSSE';

export const GlobalOrderNotifications: React.FC = () => {
  const queryClient = useQueryClient();

  const onNewOrder = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['orders'] });
    queryClient.invalidateQueries({ queryKey: ['order-statistics'] });
  }, [queryClient]);

  const onOrderUpdated = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['orders'] });
    queryClient.invalidateQueries({ queryKey: ['order-statistics'] });
  }, [queryClient]);

  const onOrderCancelled = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['orders'] });
    queryClient.invalidateQueries({ queryKey: ['order-statistics'] });
  }, [queryClient]);

  // Listen globally to all incoming orders to trigger the background sound
  useOrderSSE({
    onNewOrder,
    onOrderUpdated,
    onOrderCancelled,
    enabled: true,
  });

  return null; // purely a logic component
};

export default GlobalOrderNotifications;
